import service from '@tencent/tks-utils/promise/service';
import TksAccount from './TksAccout';

const SSO_URL = {
  // 登录接口
  common: '/shop_manage/user_info/get',
  iframe: '/integral_mall/shop_manage/user_info/get',
};

// eslint-disable-next-line no-unused-vars
let SSO_URL_ID = 'common';
if (window.location.origin === 'https://tianshu.map.qq.com' || window.location.origin === 'https://tianshutest.sparta.html5.qq.com') { // 嵌套走该接口
  SSO_URL_ID = 'iframe';
}

export default new TksAccount({
  /**
   * @desc 获取用户信息
   * @param {*} options
   * @returns {userInfo, roles}
   */
  // eslint-disable-next-line no-unused-vars
  async authPromise() {
    const url = SSO_URL[SSO_URL_ID];
    const { data: response } = await service({
      url,
      params: {
        t: new Date().getTime(),
      },
    });

    if (response.status !== 200) {
      // eslint-disable-next-line
      return Promise.reject({
        code: response.status,
        message: response.msg,
      });
    }

    return {
      userInfo: response?.data?.user_info || {},
      roles: response?.data?.access_code_list || [],
    };
  },
});
